module.exports = __webpack_public_path__ + "88a5b041c0b26cfa2badafc780f219f8.svg";